import React from "react";

const OrgProfile = () => {
  return <div>OrgProfile</div>;
};

export default OrgProfile;
